/* eslint-disable no-confusing-arrow */
// import phoneRegex from 'phone-regex';
import emailRegex from 'regex-email';

export const required = (value) => (value?.trim() ? undefined : 'Required');
export const maxLength = (max) => (value) => value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const validateEmail = (email) => {
  if (!email) {
    return undefined;
  }
  if (emailRegex.test(email.trim())) {
    return undefined;
  }
  return 'Input valid email address';
};
//
// export const validatePhone = (phoneNumber) => {
//   if (!phoneNumber) {
//     return undefined;
//   }
//   if (phoneRegex().test(phoneNumber)) {
//     return undefined;
//   }
//   return 'Input valid phone number';
// };
//

export const requiredDate = (value) => {
  if (!value) {
    return 'Due date is Required';
  }
  return undefined;
};

export const validateLatitude = (lat) => {
  if (!lat) { return undefined; }
  return Number.isFinite(Number(lat)) && Math.abs(lat) <= 90
    ? undefined : 'Latitude must be between -90 and 90';
};

export const validateLongitude = (lng) => {
  if (!lng) { return undefined; }
  return Number.isFinite(Number(lng)) && Math.abs(lng) <= 180
    ? undefined : 'Latitude must be between -180 and 180';
};
